module.exports = __webpack_public_path__ + "img/model-4.77bc0a92.svg";